import { query_group_by_org_list } from 'liyu-pc-base/api/org-model';
import { useUserStore } from 'liyu-pc-base/init-plugin';

export default () => {
  const userStore = useUserStore();
  const org = userStore.currentOrg;
  const search_config: any = {
    model: {
      org_id: org?.id,
      aim_org_id: org?.id,
      is_active: true,
      page_index: 1,
      page_size: 2000,
    },
  };
  return {
    getData: query_group_by_org_list,
    searchConfig: search_config,
  };
};
